<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

  import {
    getCookie,
    checkCookie,
    delCookie
  } from '../utils/cookie.js';

  function killErrors() {
    return true;
  }
  window.onerror = killErrors;
  export default {
    components: {},
    props: {},
    data() {
      return {}
    },
    computed: {},
    watch: {},

    onShow() {
      console.log('1')
    },
    created() {},

    updated() {
      window.scroll(0, 0)
    },
    mounted() {
      // 添加监听事件
      document.addEventListener("visibilitychange", this.handleVisiable);
    },
    methods: {
      handleVisiable: function (e) {

        if (e.target.visibilityState == "visible") {
          if (checkCookie('id') && !sessionStorage.id) {
           location.reload();
          } else if (!checkCookie('id') && sessionStorage.id) {
           location.reload();
          } else if ((sessionStorage.id && checkCookie('id')) && sessionStorage.id != getCookie('id')) {
           location.reload();
          }
        }
      },
    },
    beforeDestroy() {
      document.removeEventListener('visibilitychange', this.handleVisiable)
    },



  }

</script>

<style lang="less">
  body {
    overflow-x: hidden;
  }

  // * {
  //   /*隐藏滚动条，当IE下溢出，仍然可以滚动*/
  //   // -ms-overflow-style: none;
  //   /*火狐下隐藏滚动条*/
  //   // scrollbar-width: none;
  // }

  // html {
  //   /*隐藏滚动条，当IE下溢出，仍然可以滚动*/
  //   // -ms-overflow-style: none;
  //   /*火狐下隐藏滚动条*/
  //   // scrollbar-width: none;
  // }

  // @font-face{
  //   font-family: "微软雅黑" !important;
  // }

  /deep/ .w-e-text-container p {
    color: red;
  }

  body {
    background-color: #fcfbfb;

    table {
      td {
        border: 1px solid #000 !important;
        height: 25px;
        line-height: 25px;
        text-align: center;
        padding: none;
      }
    }

    img {
      cursor: pointer;
    }
  }

  @font-face {
    font-family: "HanWangKaiBold-Gb5";
    src: url("../static/fontFile/HanWangKaiBold-Gb5.ttf");
  }

  .el-dialog__header {
    background: #E60012 !important;
    text-align: center;
  }

  .el-dialog__title {
    line-height: 24px;
    font-size: 18px;
    color: #fff !important;
  }

  .el-message-box {
    width: 475px !important
  }

  .el-message-box__btns {
    padding: 15px 15px 0 !important;
  }

  .el-message-box__message p {
    font-size: 18px;
  }

  .el-message-box__title {
    font-size: 20px !important;
  }

  //解决切换页面时抖动问题
  html {
    overflow-y: scroll
  }


  /*文字无缝滚动*/
  #bos {
    width: 600px;
    height: 32px;
    line-height: 30px;
    overflow: hidden;
    transition: all 1s;
  }

  .anim {
    transition: all 1s;
  }

  #con1 li {
    list-style: none;
    line-height: 30px;
    height: 30px;
  }

</style>
